import React, { useMemo } from 'react';
import '../../../globalStyles/css/bootstrap/bootstrap.min.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import PrimaryDataTable from '../../../components/PrimaryDataTable';

export default function ProductsUpdateApprovalScreen({
  columns,
  approvalData,
  approvalLoading,
  approvalTotalRows,
  approvalPage,
  setApprovalPage,
  approvedData,
  approvedLoading,
  approvedTotalRows,
  approvedPage,
  setApprovedPage,
  declinedData,
  declinedLoading,
  declinedTotalRows,
  declinedPage,
  setDeclinedPage,
  activeTab,
  handleSelectActiveTab,
}) {
  return (
    <div className="container-fluid" style={{ padding: 30 }}>
      <br />
      <div className="col-md-12">
        <h4 className="headline">Product Update Approval</h4>
        <br />
        <Tabs
          defaultActiveKey={activeTab}
          id="uncontrolled-tab"
          className="default-tab"
          onSelect={(k) => handleSelectActiveTab(k)}
        >
          <Tab
            className="default-tab-content"
            eventKey="approval"
            title="Product Update Details for Approval"
          >
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex flex-row">
                  <PrimaryDataTable
                    columns={columns}
                    rows={JSON.parse(JSON.stringify(approvalData))}
                    loading={approvalLoading}
                    pageSize={50}
                    rowCount={approvalTotalRows}
                    paginationMode="server"
                    page={approvalPage}
                    onPageChange={(page) => {
                      setApprovalPage(page);
                    }}
                  />
                </div>
              </div>
            </div>
          </Tab>
          <Tab
            className="default-tab-content"
            eventKey="appproved"
            title="Approved Updates"
          >
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex flex-row">
                  <PrimaryDataTable
                    columns={columns}
                    rows={JSON.parse(JSON.stringify(approvedData))}
                    loading={approvedLoading}
                    rowCount={approvedTotalRows}
                    paginationMode="server"
                    page={approvedPage}
                    onPageChange={(page) => {
                      setApprovedPage(page);
                    }}
                  />
                </div>
              </div>
            </div>
          </Tab>
          <Tab
            className="default-tab-content"
            eventKey="declined"
            title="Declined Updates"
          >
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex flex-row">
                  <PrimaryDataTable
                    columns={columns}
                    rows={JSON.parse(JSON.stringify(declinedData))}
                    loading={declinedLoading}
                    rowCount={declinedTotalRows}
                    paginationMode="server"
                    page={declinedPage}
                    onPageChange={(page) => {
                      setDeclinedPage(page);
                    }}
                  />
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
